module.exports = __webpack_public_path__ + "teqbahn-assets/media/TeqitCloud.3bf37d44.gif";